
export { default as minifyQuery } from "./minifyQuery.utils"
export { tagDataModify } from "./graphqlDataModify.utils"